<div class="bulk-job-progress" *ngIf="job">
  <mat-progress-bar
    [mode]="progressMode"
    [value]="progressValue"
    [color]="job.status === 'error' ? 'warn' : 'primary'">
  </mat-progress-bar>

  <p class="mt-2 mb-0" *ngIf="job.status === 'queued'">Queued — starting shortly&hellip;</p>
  <p class="mt-2 mb-0" *ngIf="job.status === 'processing'">
    Processing {{ job.processedItems }} of {{ job.totalItems }}&hellip;
  </p>
  <p class="mt-2 mb-0" *ngIf="job.status === 'done'">Done.</p>
  <p class="mt-2 mb-0 text-danger" *ngIf="job.status === 'error'">
    {{ job.msg || 'Something went wrong processing this batch.' }}
  </p>
</div>
